import { useEffect, useMemo, useRef, useState } from "react";

// Schlanke internationale Telefon-Eingabe: Ländervorwahl im Dropdown (Flagge,
// Suche, Auto-Vorauswahl aus Browser-Region), daneben die lokale Nummer.
// Emittiert über onChange die zusammengesetzte E.164-Nummer ("+" + Vorwahl +
// Nummer ohne führende 0) oder "" wenn keine Nummer eingegeben ist.

interface Country {
  iso: string; // ISO-3166-1 alpha-2
  dial: string; // ohne "+"
  name: string; // deutscher Name
}

// Vollständige Länderliste. DACH zuerst (häufigste Wahl), dann alphabetisch.
// Suche macht die Länge handhabbar. Israel bewusst nicht enthalten.
const COUNTRIES: Country[] = [
  { iso: "DE", dial: "49", name: "Deutschland" },
  { iso: "AT", dial: "43", name: "Österreich" },
  { iso: "CH", dial: "41", name: "Schweiz" },
  { iso: "AF", dial: "93", name: "Afghanistan" },
  { iso: "EG", dial: "20", name: "Ägypten" },
  { iso: "AL", dial: "355", name: "Albanien" },
  { iso: "DZ", dial: "213", name: "Algerien" },
  { iso: "AD", dial: "376", name: "Andorra" },
  { iso: "AO", dial: "244", name: "Angola" },
  { iso: "AG", dial: "1", name: "Antigua und Barbuda" },
  { iso: "GQ", dial: "240", name: "Äquatorialguinea" },
  { iso: "AR", dial: "54", name: "Argentinien" },
  { iso: "AM", dial: "374", name: "Armenien" },
  { iso: "AZ", dial: "994", name: "Aserbaidschan" },
  { iso: "ET", dial: "251", name: "Äthiopien" },
  { iso: "AU", dial: "61", name: "Australien" },
  { iso: "BS", dial: "1", name: "Bahamas" },
  { iso: "BH", dial: "973", name: "Bahrain" },
  { iso: "BD", dial: "880", name: "Bangladesch" },
  { iso: "BB", dial: "1", name: "Barbados" },
  { iso: "BY", dial: "375", name: "Belarus" },
  { iso: "BE", dial: "32", name: "Belgien" },
  { iso: "BZ", dial: "501", name: "Belize" },
  { iso: "BJ", dial: "229", name: "Benin" },
  { iso: "BT", dial: "975", name: "Bhutan" },
  { iso: "BO", dial: "591", name: "Bolivien" },
  { iso: "BA", dial: "387", name: "Bosnien und Herzegowina" },
  { iso: "BW", dial: "267", name: "Botswana" },
  { iso: "BR", dial: "55", name: "Brasilien" },
  { iso: "BN", dial: "673", name: "Brunei" },
  { iso: "BG", dial: "359", name: "Bulgarien" },
  { iso: "BF", dial: "226", name: "Burkina Faso" },
  { iso: "BI", dial: "257", name: "Burundi" },
  { iso: "CL", dial: "56", name: "Chile" },
  { iso: "CN", dial: "86", name: "China" },
  { iso: "CR", dial: "506", name: "Costa Rica" },
  { iso: "DK", dial: "45", name: "Dänemark" },
  { iso: "CD", dial: "243", name: "Demokratische Republik Kongo" },
  { iso: "DM", dial: "1", name: "Dominica" },
  { iso: "DO", dial: "1", name: "Dominikanische Republik" },
  { iso: "DJ", dial: "253", name: "Dschibuti" },
  { iso: "EC", dial: "593", name: "Ecuador" },
  { iso: "SV", dial: "503", name: "El Salvador" },
  { iso: "CI", dial: "225", name: "Elfenbeinküste" },
  { iso: "ER", dial: "291", name: "Eritrea" },
  { iso: "EE", dial: "372", name: "Estland" },
  { iso: "SZ", dial: "268", name: "Eswatini" },
  { iso: "FJ", dial: "679", name: "Fidschi" },
  { iso: "FI", dial: "358", name: "Finnland" },
  { iso: "FR", dial: "33", name: "Frankreich" },
  { iso: "FO", dial: "298", name: "Färöer" },
  { iso: "GA", dial: "241", name: "Gabun" },
  { iso: "GM", dial: "220", name: "Gambia" },
  { iso: "GE", dial: "995", name: "Georgien" },
  { iso: "GH", dial: "233", name: "Ghana" },
  { iso: "GI", dial: "350", name: "Gibraltar" },
  { iso: "GD", dial: "1", name: "Grenada" },
  { iso: "GR", dial: "30", name: "Griechenland" },
  { iso: "GL", dial: "299", name: "Grönland" },
  { iso: "GT", dial: "502", name: "Guatemala" },
  { iso: "GN", dial: "224", name: "Guinea" },
  { iso: "GW", dial: "245", name: "Guinea-Bissau" },
  { iso: "GY", dial: "592", name: "Guyana" },
  { iso: "HT", dial: "509", name: "Haiti" },
  { iso: "HN", dial: "504", name: "Honduras" },
  { iso: "HK", dial: "852", name: "Hongkong" },
  { iso: "IN", dial: "91", name: "Indien" },
  { iso: "ID", dial: "62", name: "Indonesien" },
  { iso: "IQ", dial: "964", name: "Irak" },
  { iso: "IR", dial: "98", name: "Iran" },
  { iso: "IE", dial: "353", name: "Irland" },
  { iso: "IS", dial: "354", name: "Island" },
  { iso: "IT", dial: "39", name: "Italien" },
  { iso: "JM", dial: "1", name: "Jamaika" },
  { iso: "JP", dial: "81", name: "Japan" },
  { iso: "YE", dial: "967", name: "Jemen" },
  { iso: "JO", dial: "962", name: "Jordanien" },
  { iso: "KH", dial: "855", name: "Kambodscha" },
  { iso: "CM", dial: "237", name: "Kamerun" },
  { iso: "CA", dial: "1", name: "Kanada" },
  { iso: "CV", dial: "238", name: "Kap Verde" },
  { iso: "KZ", dial: "7", name: "Kasachstan" },
  { iso: "QA", dial: "974", name: "Katar" },
  { iso: "KE", dial: "254", name: "Kenia" },
  { iso: "KG", dial: "996", name: "Kirgisistan" },
  { iso: "KI", dial: "686", name: "Kiribati" },
  { iso: "CO", dial: "57", name: "Kolumbien" },
  { iso: "KM", dial: "269", name: "Komoren" },
  { iso: "XK", dial: "383", name: "Kosovo" },
  { iso: "HR", dial: "385", name: "Kroatien" },
  { iso: "CU", dial: "53", name: "Kuba" },
  { iso: "KW", dial: "965", name: "Kuwait" },
  { iso: "LA", dial: "856", name: "Laos" },
  { iso: "LS", dial: "266", name: "Lesotho" },
  { iso: "LV", dial: "371", name: "Lettland" },
  { iso: "LB", dial: "961", name: "Libanon" },
  { iso: "LR", dial: "231", name: "Liberia" },
  { iso: "LY", dial: "218", name: "Libyen" },
  { iso: "LI", dial: "423", name: "Liechtenstein" },
  { iso: "LT", dial: "370", name: "Litauen" },
  { iso: "LU", dial: "352", name: "Luxemburg" },
  { iso: "MO", dial: "853", name: "Macau" },
  { iso: "MG", dial: "261", name: "Madagaskar" },
  { iso: "MW", dial: "265", name: "Malawi" },
  { iso: "MY", dial: "60", name: "Malaysia" },
  { iso: "MV", dial: "960", name: "Malediven" },
  { iso: "ML", dial: "223", name: "Mali" },
  { iso: "MT", dial: "356", name: "Malta" },
  { iso: "MA", dial: "212", name: "Marokko" },
  { iso: "MH", dial: "692", name: "Marshallinseln" },
  { iso: "MR", dial: "222", name: "Mauretanien" },
  { iso: "MU", dial: "230", name: "Mauritius" },
  { iso: "MX", dial: "52", name: "Mexiko" },
  { iso: "FM", dial: "691", name: "Mikronesien" },
  { iso: "MD", dial: "373", name: "Moldau" },
  { iso: "MC", dial: "377", name: "Monaco" },
  { iso: "MN", dial: "976", name: "Mongolei" },
  { iso: "ME", dial: "382", name: "Montenegro" },
  { iso: "MZ", dial: "258", name: "Mosambik" },
  { iso: "MM", dial: "95", name: "Myanmar" },
  { iso: "NA", dial: "264", name: "Namibia" },
  { iso: "NR", dial: "674", name: "Nauru" },
  { iso: "NP", dial: "977", name: "Nepal" },
  { iso: "NZ", dial: "64", name: "Neuseeland" },
  { iso: "NI", dial: "505", name: "Nicaragua" },
  { iso: "NL", dial: "31", name: "Niederlande" },
  { iso: "NE", dial: "227", name: "Niger" },
  { iso: "NG", dial: "234", name: "Nigeria" },
  { iso: "KP", dial: "850", name: "Nordkorea" },
  { iso: "MK", dial: "389", name: "Nordmazedonien" },
  { iso: "NO", dial: "47", name: "Norwegen" },
  { iso: "OM", dial: "968", name: "Oman" },
  { iso: "TL", dial: "670", name: "Osttimor" },
  { iso: "PK", dial: "92", name: "Pakistan" },
  { iso: "PW", dial: "680", name: "Palau" },
  { iso: "PS", dial: "970", name: "Palästina" },
  { iso: "PA", dial: "507", name: "Panama" },
  { iso: "PG", dial: "675", name: "Papua-Neuguinea" },
  { iso: "PY", dial: "595", name: "Paraguay" },
  { iso: "PE", dial: "51", name: "Peru" },
  { iso: "PH", dial: "63", name: "Philippinen" },
  { iso: "PL", dial: "48", name: "Polen" },
  { iso: "PT", dial: "351", name: "Portugal" },
  { iso: "CG", dial: "242", name: "Republik Kongo" },
  { iso: "RW", dial: "250", name: "Ruanda" },
  { iso: "RO", dial: "40", name: "Rumänien" },
  { iso: "RU", dial: "7", name: "Russland" },
  { iso: "SB", dial: "677", name: "Salomonen" },
  { iso: "ZM", dial: "260", name: "Sambia" },
  { iso: "WS", dial: "685", name: "Samoa" },
  { iso: "SM", dial: "378", name: "San Marino" },
  { iso: "ST", dial: "239", name: "São Tomé und Príncipe" },
  { iso: "SA", dial: "966", name: "Saudi-Arabien" },
  { iso: "SE", dial: "46", name: "Schweden" },
  { iso: "SN", dial: "221", name: "Senegal" },
  { iso: "RS", dial: "381", name: "Serbien" },
  { iso: "SC", dial: "248", name: "Seychellen" },
  { iso: "SL", dial: "232", name: "Sierra Leone" },
  { iso: "ZW", dial: "263", name: "Simbabwe" },
  { iso: "SG", dial: "65", name: "Singapur" },
  { iso: "SK", dial: "421", name: "Slowakei" },
  { iso: "SI", dial: "386", name: "Slowenien" },
  { iso: "SO", dial: "252", name: "Somalia" },
  { iso: "ES", dial: "34", name: "Spanien" },
  { iso: "LK", dial: "94", name: "Sri Lanka" },
  { iso: "KN", dial: "1", name: "St. Kitts und Nevis" },
  { iso: "LC", dial: "1", name: "St. Lucia" },
  { iso: "VC", dial: "1", name: "St. Vincent und die Grenadinen" },
  { iso: "SD", dial: "249", name: "Sudan" },
  { iso: "SR", dial: "597", name: "Suriname" },
  { iso: "SY", dial: "963", name: "Syrien" },
  { iso: "ZA", dial: "27", name: "Südafrika" },
  { iso: "KR", dial: "82", name: "Südkorea" },
  { iso: "SS", dial: "211", name: "Südsudan" },
  { iso: "TJ", dial: "992", name: "Tadschikistan" },
  { iso: "TW", dial: "886", name: "Taiwan" },
  { iso: "TZ", dial: "255", name: "Tansania" },
  { iso: "TH", dial: "66", name: "Thailand" },
  { iso: "TG", dial: "228", name: "Togo" },
  { iso: "TO", dial: "676", name: "Tonga" },
  { iso: "TT", dial: "1", name: "Trinidad und Tobago" },
  { iso: "TD", dial: "235", name: "Tschad" },
  { iso: "CZ", dial: "420", name: "Tschechien" },
  { iso: "TN", dial: "216", name: "Tunesien" },
  { iso: "TM", dial: "993", name: "Turkmenistan" },
  { iso: "TV", dial: "688", name: "Tuvalu" },
  { iso: "TR", dial: "90", name: "Türkei" },
  { iso: "UG", dial: "256", name: "Uganda" },
  { iso: "UA", dial: "380", name: "Ukraine" },
  { iso: "HU", dial: "36", name: "Ungarn" },
  { iso: "UY", dial: "598", name: "Uruguay" },
  { iso: "US", dial: "1", name: "USA" },
  { iso: "UZ", dial: "998", name: "Usbekistan" },
  { iso: "VU", dial: "678", name: "Vanuatu" },
  { iso: "VE", dial: "58", name: "Venezuela" },
  { iso: "AE", dial: "971", name: "Vereinigte Arabische Emirate" },
  { iso: "GB", dial: "44", name: "Vereinigtes Königreich" },
  { iso: "VN", dial: "84", name: "Vietnam" },
  { iso: "CF", dial: "236", name: "Zentralafrikanische Republik" },
  { iso: "CY", dial: "357", name: "Zypern" },
];

// COUNTRIES ist ein nicht-leeres Literal — sicherer Default fürs Typsystem.
const DEFAULT_COUNTRY: Country = COUNTRIES[0]!;

// Flagge aus ISO-Code (Regional-Indicator-Symbole) — kein Hardcoding nötig.
function flag(iso: string): string {
  return iso
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

// Zeitzone -> Land: besserer Standort-Indikator als die Sprache (ein deutscher
// Nutzer mit englischem Handy hat trotzdem Europe/Berlin). Nur die für uns
// relevanten Zonen; alles andere fällt auf Sprache bzw. DE zurück.
const TZ_TO_ISO: Record<string, string> = {
  "Europe/Berlin": "DE", "Europe/Busingen": "DE",
  "Europe/Vienna": "AT", "Europe/Zurich": "CH", "Europe/Paris": "FR",
  "Europe/Rome": "IT", "Europe/Madrid": "ES", "Europe/Amsterdam": "NL",
  "Europe/Brussels": "BE", "Europe/Luxembourg": "LU", "Europe/London": "GB",
  "Europe/Dublin": "IE", "Europe/Lisbon": "PT", "Europe/Warsaw": "PL",
  "Europe/Prague": "CZ", "Europe/Bratislava": "SK", "Europe/Budapest": "HU",
  "Europe/Copenhagen": "DK", "Europe/Stockholm": "SE", "Europe/Oslo": "NO",
  "Europe/Helsinki": "FI", "Atlantic/Reykjavik": "IS", "Europe/Athens": "GR",
  "Europe/Bucharest": "RO", "Europe/Sofia": "BG", "Europe/Zagreb": "HR",
  "Europe/Ljubljana": "SI", "Europe/Belgrade": "RS", "Europe/Sarajevo": "BA",
  "Europe/Podgorica": "ME", "Europe/Skopje": "MK", "Europe/Tirane": "AL",
  "Europe/Tallinn": "EE", "Europe/Riga": "LV", "Europe/Vilnius": "LT",
  "Europe/Kyiv": "UA", "Europe/Kiev": "UA", "Europe/Istanbul": "TR",
  "Asia/Nicosia": "CY", "Europe/Nicosia": "CY", "Europe/Malta": "MT",
  "Europe/Vaduz": "LI",
  "America/New_York": "US", "America/Chicago": "US", "America/Denver": "US",
  "America/Los_Angeles": "US", "America/Phoenix": "US",
  "America/Toronto": "CA", "America/Vancouver": "CA",
  "America/Sao_Paulo": "BR", "Australia/Sydney": "AU", "Pacific/Auckland": "NZ",
  "Asia/Tokyo": "JP", "Asia/Shanghai": "CN", "Asia/Kolkata": "IN",
  "Africa/Johannesburg": "ZA", "Asia/Dubai": "AE",
};

// Vorauswahl: erst Zeitzone (Standort), dann Browser-Region (Sprache), sonst DE.
function guessIso(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const fromTz = tz ? TZ_TO_ISO[tz] : undefined;
    if (fromTz && COUNTRIES.some((c) => c.iso === fromTz)) return fromTz;
    const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const l of langs) {
      const m = l?.match(/[-_]([A-Za-z]{2})\b/);
      if (m && m[1]) {
        const iso = m[1].toUpperCase();
        if (COUNTRIES.some((c) => c.iso === iso)) return iso;
      }
    }
  } catch {
    /* ignore */
  }
  return "DE";
}

// Lokale Nummer -> E.164: Ziffern extrahieren, EINE führende 0 (nationale
// Amtskennziffer) entfernen, Vorwahl voranstellen. Leer -> "".
function compose(dial: string, local: string): string {
  let digits = local.replace(/\D/g, "");
  if (digits.startsWith("0")) digits = digits.replace(/^0+/, "");
  return digits ? `+${dial}${digits}` : "";
}

// Bei geteilten Vorwahlen (mehrere Länder mit +1/+44/+7) das gängigste Land.
const PRIMARY_DIAL: Record<string, string> = { "1": "US", "44": "GB", "7": "RU" };

// Findet das Land, dessen Vorwahl das längste Präfix der Ziffern ist.
function matchDial(digits: string): Country | undefined {
  let best: Country | undefined;
  for (const c of COUNTRIES) {
    if (digits.startsWith(c.dial) && (!best || c.dial.length > best.dial.length)) best = c;
  }
  if (best) {
    const primary = PRIMARY_DIAL[best.dial];
    if (primary) return COUNTRIES.find((c) => c.iso === primary) ?? best;
  }
  return best;
}

// Bereinigt eine Nummernfeld-Eingabe:
//  - explizit international ("+49…", "0049…") -> Ländercode entfernen, ggf. das
//    gewählte Land passend umschalten (auch bei fremdem Code, z.B. +41 -> CH);
//  - bloßer aktueller Ländercode ("49…") -> vorsichtig entfernen, Land bleibt.
// Gibt { iso?, local } zurück (iso gesetzt = umschalten) oder null (nichts tun).
export function parseEntry(raw: string, currentDial: string): { iso?: string; local: string } | null {
  const t = raw.trim();
  let intl: string | null = null;
  if (t.startsWith("+")) intl = t.replace(/\D/g, "");
  else {
    const d = t.replace(/\D/g, "");
    if (d.startsWith("00")) intl = d.slice(2);
  }
  if (intl !== null) {
    const c = matchDial(intl);
    // Erst umschalten/strippen, wenn nach dem Code eine plausible Nummer steht.
    if (c && intl.length >= c.dial.length + 3) {
      return { iso: c.iso, local: intl.slice(c.dial.length).replace(/^0+/, "") };
    }
    return null;
  }
  // Bloßer aktueller Ländercode: "49…" (keine führende 0, plausible Restlänge).
  const digits = t.replace(/\D/g, "");
  if (
    digits.startsWith(currentDial) &&
    !digits.startsWith("0") &&
    digits.length > currentDial.length + 4
  ) {
    return { local: digits.slice(currentDial.length).replace(/^0+/, "") };
  }
  return null;
}

export function PhoneInput({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (composed: string) => void;
  placeholder?: string;
}) {
  const [iso, setIso] = useState<string>(() => guessIso());
  const [local, setLocal] = useState("");
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef<HTMLDivElement>(null);
  const searchRef = useRef<HTMLInputElement>(null);

  const country = COUNTRIES.find((c) => c.iso === iso) ?? DEFAULT_COUNTRY;

  // Wenn der Parent den Wert zurücksetzt (z.B. nach Absenden), Feld leeren.
  useEffect(() => {
    if (!value) setLocal("");
  }, [value]);

  // Debounced Feld-Cleanup: kurz nach dem Tippen einen eingegebenen Ländercode
  // (+49 / 0049 / 49) entfernen und ggf. das Land umschalten. Der Output an den
  // Parent ist über onLocal ohnehin schon bereinigt — das hier ist die sichtbare
  // Kosmetik, deshalb verzögert (stört nicht beim Tippen).
  useEffect(() => {
    if (!local) return;
    const id = setTimeout(() => {
      const parsed = parseEntry(local, country.dial);
      if (parsed && (parsed.local !== local || (parsed.iso && parsed.iso !== iso))) {
        const dial = parsed.iso ? COUNTRIES.find((c) => c.iso === parsed.iso)?.dial ?? country.dial : country.dial;
        if (parsed.iso && parsed.iso !== iso) setIso(parsed.iso);
        setLocal(parsed.local);
        onChange(compose(dial, parsed.local));
      }
    }, 450);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local, country.dial, iso]);

  // Außerhalb klicken / Escape schließt das Dropdown.
  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    setTimeout(() => searchRef.current?.focus(), 0);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return COUNTRIES;
    // Vorwahl suchbar: "49", "+49", "0049" -> alle finden die DE-Vorwahl.
    const qDigits = q.replace(/[^\d]/g, "").replace(/^00/, "");
    return COUNTRIES.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.iso.toLowerCase().includes(q) ||
        (qDigits !== "" && (c.dial.startsWith(qDigits) || qDigits.startsWith(c.dial))),
    );
  }, [query]);

  const pick = (c: Country) => {
    setIso(c.iso);
    setOpen(false);
    setQuery("");
    const parsed = parseEntry(local, c.dial);
    onChange(compose(c.dial, parsed && !parsed.iso ? parsed.local : local));
  };

  const onLocal = (v: string) => {
    setLocal(v);
    // Output sofort bereinigt (falls direkt abgesendet wird); die sichtbare
    // Feld-Bereinigung passiert verzögert über den Debounce-Effekt oben.
    const parsed = parseEntry(v, country.dial);
    const dial = parsed?.iso ? COUNTRIES.find((c) => c.iso === parsed.iso)?.dial ?? country.dial : country.dial;
    onChange(compose(dial, parsed ? parsed.local : v));
  };

  return (
    <div ref={wrapRef} className="relative">
      <div className="flex">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-label="Ländervorwahl wählen"
          className="flex shrink-0 items-center gap-1.5 rounded-l-xl border border-r-0 border-[#E4D9E0] bg-slate-50 px-3 text-sm font-medium text-slate-700 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-brand-200"
        >
          <span className="text-base leading-none">{flag(country.iso)}</span>
          <span>+{country.dial}</span>
          <span className="text-slate-400" aria-hidden>▾</span>
        </button>
        <input
          type="tel"
          inputMode="tel"
          autoComplete="tel-national"
          className="input rounded-l-none"
          value={local}
          onChange={(e) => onLocal(e.target.value)}
          placeholder={placeholder ?? "170 1234567"}
        />
      </div>

      {open && (
        <div className="absolute z-20 mt-1 w-full max-w-sm rounded-xl border border-[#E4D9E0] bg-white shadow-lg">
          <div className="border-b border-slate-100 p-2">
            <input
              ref={searchRef}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Land oder Vorwahl suchen…"
              className="w-full rounded-lg border border-[#E4D9E0] px-3 py-2 text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-200"
            />
          </div>
          <ul className="max-h-60 overflow-y-auto py-1">
            {filtered.map((c) => (
              <li key={c.iso}>
                <button
                  type="button"
                  onClick={() => pick(c)}
                  className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-sm hover:bg-slate-50 ${
                    c.iso === iso ? "bg-brand-50 font-medium" : ""
                  }`}
                >
                  <span className="text-base leading-none">{flag(c.iso)}</span>
                  <span className="flex-1 truncate text-slate-700">{c.name}</span>
                  <span className="text-slate-400">+{c.dial}</span>
                </button>
              </li>
            ))}
            {filtered.length === 0 && (
              <li className="px-3 py-3 text-center text-sm text-slate-400">Keine Treffer</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
